import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import { IMatchingInvoices } from 'src/types/IMatchingInvoice';
import axiosInstance from 'src/utils/axios';
import { removeTime } from 'src/utils/formatTime';

interface MatchInvoicesRequest {
  invoiceNumber: string;
  companyId: string;
}

const useGetMatchInvoicesApi = () => {
  const call = useCallback(
    (params?: MatchInvoicesRequest) =>
      new Promise<IMatchingInvoices[]>(async (resolve, reject) => {
        try {
          const invoiceNumberEncoded = encodeURIComponent(params?.invoiceNumber || '');
          const response = await axiosInstance.get<IMatchingInvoices[]>(
            api.getInvoiceMatches(invoiceNumberEncoded, params?.companyId as string)
          );
          const data = response.data.map((doc) => ({
            ...doc,
            statusDate: doc.statusDate ? removeTime(new Date(doc.statusDate)) : null,
          }));
          resolve(data as IMatchingInvoices[]);
        } catch (error) {
          reject(error);
        }
      }),
    []
  );

  const { execute, isLoading } = useAsync(call, false);
  return { getInvoiceMatches: execute, invoiceMatchesLoading: isLoading };
};

export default useGetMatchInvoicesApi;
